module.exports = __webpack_public_path__ + "static/media/intellitrade-expanded-logo.973a232a.svg";